import { REACT_APP_OKTA_CLIENT_ID } from "shared/constants";
export const oktaAuthConfig = {
  issuer: 'https://auth.weaveconnect.com/oauth2/default',
  clientId: REACT_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/form-submissions`,
  scopes: ['openid', 'email', 'profile'],
};
